module.exports = __webpack_public_path__ + "static/media/Sudantha.4eaa134e.jpg";